export const NON_EXISTENT_PARENT_COMMENT_ID = 0
export const ACCESS_CONDITION_PUBLIC = 'PUBLIC'
export const SEGMENTED_ARTICLE_EXPERIMENT_IDS = [1796026125, 2552559416, 2488519687]
export const PLACEHOLDER_BANNER_NAME = 'data-orientation-banner'
